import { useLang } from '../../contexts/LangContext'
import { normalizeLocale } from '../../lib/i18n'
import StarRatingDisplay from './StarRatingDisplay'

export interface ReviewCardData {
  id: string
  rating: number
  comment: string | null
  createdAt: string
  reviewer: {
    firstName: string
    lastName: string
  }
}

function formatReviewDate(dateValue: string, locale: 'el' | 'en') {
  return new Intl.DateTimeFormat(locale === 'el' ? 'el-GR' : 'en-GB', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(dateValue))
}

export default function ReviewCard({
  review,
  placeholder,
}: {
  review: ReviewCardData
  placeholder: string
}) {
  const { locale } = useLang()
  const activeLocale = normalizeLocale(locale)
  const reviewerLabel = review.reviewer.lastName
    ? `${review.reviewer.firstName} ${review.reviewer.lastName.charAt(0)}.`
    : review.reviewer.firstName

  return (
    <article className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-sm font-semibold text-slate-950">{reviewerLabel}</p>
          <p className="mt-1 text-xs font-medium uppercase tracking-[0.14em] text-slate-400">
            {formatReviewDate(review.createdAt, activeLocale)}
          </p>
        </div>
        <div className="inline-flex items-center gap-2 rounded-full bg-amber-50 px-3 py-1 text-sm font-semibold text-amber-700">
          <StarRatingDisplay rating={review.rating} size={14} />
          {review.rating.toFixed(1)}
        </div>
      </div>
      <p className="mt-4 text-sm leading-7 text-slate-600">
        {review.comment?.trim() || placeholder}
      </p>
    </article>
  )
}
